// extracted by mini-css-extract-plugin
module.exports = {"slickSliderReset":"styles_slickSliderReset__0sOJj"};